<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AWcutH/tc-custom/9781250100719.jpg?1730640566749" alt="This image is the cover for the book Eisenhower, Great Generals Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eisenhower, Great Generals Series
      </h1>
      <p class="bookDescription body article font2">
        <b>“A concise portrayal of the commander who served as the chief architect of D-Day.” —Col. Cole C. Kingseed, <i>New York Times</i>–bestselling coauthor of <i>Beyond Band of Brothers</i></b><br/><br/>American general and thirty-fourth US president Dwight D. Eisenhower was the principal architect of the successful Allied invasion of Europe during World War II, and the subsequent defeat of Nazi Germany. In this biography, military historian John Wukovits explores Eisenhower’s contributions to American warfare. <br/><br/>Eisenhower led the assault on the French coast at Normandy and held together the Allied units through the European campaign that followed. The book reveals Eisenhower’s advocacy in the pre-war years of the tank, his friendships with George Patton and Fox Conner, his service in the Philippines with Douglas MacArthur, and his culminating role as supreme commander of Allied forces in Europe.<br/><br/>With an introduction by General Wesley Clark, <i>Eisenhower</i> skillfully demonstrates how Dwight Eisenhower’s evolution as a commander, his military doctrine, and his diplomatic skills are of extreme importance in understanding modern warfare.<br/><br/>“A portrait of a general who devised and sustained a broad-front strategy that led to Germany’s unconditional surrender, and a man who never took his eyes off the prize.” —<i>The Star-Ledger</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Wukovits, Wesley K. Clark
      </h2>
      
      <p class="authorDescription body article"><B>John Wukovits</B> is the author of <I>Pacific Alamo </I>and <I>Devotion to Duty.</I> His writings have appeared in numerous publications including <I>The Washington Post</I> and the <I>Chicago Tribune</I>. He lives in Trenton, Michigan.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?14f975d3